import each from 'lodash/each';
import get from 'lodash/get';
import has from 'lodash/has';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import reject from 'lodash/reject';
import { API } from 'aws-amplify';
import { getWinstonLogger } from '@last-rev/logging';
import axios from 'axios';
import { getLearnApiRequestConfig } from '../../../apis/learnApiRequest';

import {
  LOAD_COMPLETED_COURSES,
  ADD_COMPLETED_COURSE,
  LOADING_COMPLETED_COURSES,
  LOADING_COMPLETED_COURSE_TOPICS,
  LOAD_COMPLETED_COURSE_TOPICS,
  ADD_COMPLETED_COURSE_TOPIC,
  LOADING_COMPLETED_TOPICS,
  LOAD_COMPLETED_TOPICS
} from './courses.types';
import logger from '../../../logger';

const apiName = process.env.ENDPOINT_NAME;
const datadogLogger = getWinstonLogger({ path: 'src/redux/modules/courses', filename: 'courses.actions.js' });
const getDbType = () => {
  const host = window.location.hostname;
  const db = `${host && host.includes('learn-stage')||host.includes('localhost')? process.env.STG_DB : process.env.PROD_DB}`
  return db;
};

export const loadCompletedCourses = () => async (dispatch, getState) => {
  const {
    user: { id: userId }
  } = getState();
  if (!userId) return;
  dispatch({
    type: LOADING_COMPLETED_COURSES
  });

  try {
    const data = JSON.stringify({
      user_id: userId,
      dbtype: getDbType()

    })
    const response = await axios({
      method: 'post',
      ...(await getLearnApiRequestConfig('/list_courses')),
      data
    });
    const { items: completedCourses } = response.data;

    const completed = keyBy(completedCourses, 'courseid');

    dispatch({
      type: LOAD_COMPLETED_COURSES,
      payload: {
        completed
      }
    });
  } catch (error) {
    logger.error(error);
    datadogLogger.error(error);
    dispatch({
      type: LOAD_COMPLETED_COURSES,
      payload: {
        completed: {}
      }
    });
  }
};

export const completeCourse = (courseId) => async (dispatch, getState) => {

  try {
    const {
      user: { id: userId },
      courses: { completed }
    } = getState();
    if (!courseId || has(completed, courseId)) return;

    const data = JSON.stringify({
      user_id: userId,
      course_id: courseId,
      dbtype: getDbType()

    })
    const response = await axios({
      method: 'post',
      ...(await getLearnApiRequestConfig('/create_course')),
      data
    });
     const courseData = response?.data
   
    dispatch({
      type: ADD_COMPLETED_COURSE,
      payload: {
        courseData
      }
    });
  } catch (error) {
    logger.error(error);
    datadogLogger.error(error);
  }
};

export const setViewedCompletiondMessageForCourse = (courseId) => async (dispatch, getState) => {
  try {
    const {
      courses: { completed },
      user: { id: userId }
    } = getState();

    if (!userId || !courseId || !has(completed, courseId)) return;

    const data = JSON.stringify({
      user_id: userId,
      course_id: courseId,
       viewedcompletionmessage: "true",
      dbtype: getDbType()

    })
    const response = await axios({
      method: 'post',
      ...(await getLearnApiRequestConfig('/update_courses')),
      data
    });
    if (!result.success) throw Error('unsuccessful update');

    const course = get(completed, courseId);

    dispatch({
      type: ADD_COMPLETED_COURSE,
      payload: {
        course: {
          ...course,
          viewedCompletionMessage: true
        }
      }
    });
  } catch (err) {
    logger.error(err);
    datadogLogger.error(err);
  }
};

export const loadCompletedTopicsForCourse = (courseId) => async (dispatch, getState) => {
  try {
    const {
      user: { id: userId }
    } = getState();
    if (!userId) return null;
    if (!courseId) return null;
    dispatch({
      type: LOADING_COMPLETED_COURSE_TOPICS
    });

    const path = '/topics/listbyuserid';
    const response = await API.get(apiName, path, {
      queryStringParameters: {
        user_id: userId,
        course_id: courseId
      }
    });

    const { items: completedTopics } = response;
    const completedTopicsForCourse = keyBy(completedTopics, 'topicId');

    return dispatch({
      type: LOAD_COMPLETED_COURSE_TOPICS,
      payload: {
        courseId,
        completedTopicsForCourse
      }
    });
  } catch (error) {
    logger.error(error);
    datadogLogger.error(error);
    return dispatch({
      type: LOAD_COMPLETED_COURSE_TOPICS,
      payload: {
        courseId,
        completedTopicsForCourse: {}
      }
    });
  }
};

export const loadAllCompletedTopics = () => async (dispatch, getState) => {
  try {
    const {
      user: { id: userId }
    } = getState();
    if (!userId) return null;
    dispatch({
      type: LOADING_COMPLETED_TOPICS
    });

      const data = JSON.stringify({
      user_id: userId,
      dbtype: getDbType()

    })
    const response = await axios({
      method: 'post',
      ...(await getLearnApiRequestConfig('/topics/list')),
      data
    });
     const courseData = response?.data

    const { items: completedTopics } = response?.data;
    const completedCourseTopics = {};
    each(completedTopics, (topic) => {
      if (!has(completedCourseTopics, topic.courseid)) {
        completedCourseTopics[topic.courseid] = {};
      }
      completedCourseTopics[topic.courseid][topic.topicid] = topic;
    });

    return dispatch({
      type: LOAD_COMPLETED_TOPICS,
      payload: {
        completedCourseTopics
      }
    });
  } catch (error) {
    logger.error(error);
    datadogLogger.error(error);
    return dispatch({
      type: LOAD_COMPLETED_TOPICS,
      payload: {
        completedCourseTopics: {}
      }
    });
  }
};

export const completeTopicForCourse = (topicId, courseId, courseTopics) => async (dispatch, getState) => {
  try {
    const {
      user: { id: userId },
      courses: { completedCourseTopics }
    } = getState();

    if (!topicId) return;

    const completedTopicsForCourse = get(completedCourseTopics, courseId, {});

    if (has(completedTopicsForCourse, topicId)) return;

    const courseTopicIds = map(courseTopics, '_id');
    const uncompletedTopicIds = reject(courseTopicIds, (courseTopicId) => has(completedTopicsForCourse, courseTopicId));
    const data = JSON.stringify({
      user_id: userId,
      course_id: courseId,
      topic_id: topicId,
      dbtype: getDbType()

    })
    const response = await axios({
      method: 'post',
      ...(await getLearnApiRequestConfig('/topics/create')),
      data
    });
    const topicData = response?.data?.success

    dispatch({
      type: ADD_COMPLETED_COURSE_TOPIC,
      payload: {
        courseId,
        topicData,

      }
    });
    if (uncompletedTopicIds.length === 1 && uncompletedTopicIds[0] === topicId) {
      dispatch(completeCourse(courseId));
    }
  } catch (error) {
    logger.error(error);
    datadogLogger.error(error);
  }
};
